import 'css-chunksrc/client/scenes/calendar/week/dayCreationMenu/typeSelector/styles.scss';export default {
  "typeSelector": "_typeSelector_qgf0q_1",
  "typeIcon": "_typeIcon_qgf0q_17",
  "typeLabel": "_typeLabel_qgf0q_22",
  "arrow": "_arrow_qgf0q_30",
  "arrowOpen": "_arrowOpen_qgf0q_37",
  "typeDropdown": "_typeDropdown_qgf0q_41",
  "typeOption": "_typeOption_qgf0q_50"
};